module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": this._uid
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1886490!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/map/GoogleMapPolygon.vue
// module id = 2645
// module chunks = 1